import React, { useEffect, useState } from 'react';
import { Button, Card, Col, Form, Modal, Row, Spinner } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import { fetchConToken } from '../../../api/fetch';
import { useContextInfo } from '../../../context/ContextInfo';
import { useForm } from '../../../hooks/useForm';
import { useGetDta } from '../../../hooks/useGetDta';
const initialState = {
    id: '',
    cargo: '',
    nota: '',
};
const ModCargo = ({ show, onClose, item, callBk }) => {
    const { id: ids } = useParams();

    let idR = atob(ids);
    const { setResp } = useContextInfo();

    const [load, setLoad] = useState(false);
    const [validated, setValidated] = useState(false);
    const [values, handleInputChange, reset, setFormValue] = useForm({ ...initialState });
    const { id } = values;
    useEffect(() => {
        !show ? setFormValue({ ...initialState }) : setFormValue({ ...values, ...item });
    }, [show]);

    const funClose = () => {
        if (id) {
            onClose();
        } else {
            reset();
            onClose();
        }
    };
    const onSubmit = async (e) => {
        const form = e.currentTarget;
        e.preventDefault();
        setLoad(true);
        if (form.checkValidity() === false) {
            setValidated(true);
        } else {
            let res = await fetchConToken(`usertools/cargo`, { ...values, id_user: idR }, 'POST');
            setResp(res);
            if (res.ok) {
                callBk();
                reset();
                onClose();
            }
        }
        setLoad(false);
    };

    return (
        <Modal show={show} onHide={funClose}>
            <Modal.Header onHide={funClose} closeButton>
                <h4 className="modal-title">{id ? 'Editar' : 'Nuevo'} cargo</h4>
            </Modal.Header>
            <Modal.Body>
                <>
                    <Row>
                        <Col>
                            <Card>
                                <Card.Body>
                                    <Form noValidate validated={validated} onSubmit={onSubmit}>
                                     
                                        <Form.Group className="mb-3" controlId="validationCustom999">
                                            <Form.Label>Cargo</Form.Label>
                                            <Form.Control
                                                required
                                                type="number"
                                                value={values.cargo}
                                                name="cargo"
                                                onChange={handleInputChange}
                                            />
                                            <Form.Control.Feedback>Válido</Form.Control.Feedback>
                                        </Form.Group>{' '}
                                        <Form.Group className="mb-3" controlId="validationCusto">
                                            <Form.Label>Concepto</Form.Label>
                                            <Form.Control
                                                required
                                                type="text"
                                                value={values.nota}
                                                name="nota"
                                                onChange={handleInputChange}
                                            />
                                            <Form.Control.Feedback>Válido</Form.Control.Feedback>
                                        </Form.Group>{' '}
                                        {load ? (
                                            <Button color="primary" disabled>
                                                <Spinner className="spinner-border-sm me-1" tag="span" color="white" />
                                                Guardando...
                                            </Button>
                                        ) : (
                                            <Button type="submit">Guardar</Button>
                                        )}
                                    </Form>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </>
            </Modal.Body>
        </Modal>
    );
};

export default ModCargo;
